import { Grid, Box, Typography } from '@mui/material';

import { ReactNode } from 'react';

interface IColumnTwoLayoutWithDividerProps {
	leftComponent: ReactNode;
	rightComponent: ReactNode;
}
const styles = {
	dividerLine: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		height: '100%',
		position: 'relative',
		'&::before': {
			position: 'absolute',
			background: '#D1D1D1',
			height: '100%',
			width: '1px',
			content: '""',
		},
	},
	dividerText: {
		position: 'relative',
		paddingX: 1,
		paddingY: 3,
		fontSize: '16px',
		color: '#474747',
		background: '#ebebf0',
	},
};
const ColumnTwoLayoutWithDivider = ({
	leftComponent,
	rightComponent,
}: IColumnTwoLayoutWithDividerProps) => (
	<Grid container>
		<Grid item xs={12} md={5.5}>
			{leftComponent}
		</Grid>
		<Grid item xs={12} md={1}>
			<Box sx={styles.dividerLine}>
				<Typography variant="body2" sx={styles.dividerText}>
					OR
				</Typography>
			</Box>
		</Grid>
		<Grid item xs={12} md={5.5}>
			{rightComponent}
		</Grid>
	</Grid>
);

export default ColumnTwoLayoutWithDivider;
